define('modules/editor/services/seo/index',['require','exports','module','common/models/appstate','../../views/editors/seo'],function(require,exports,module){
  "use strict";
  var AppState = require("common/models/appstate"),
      SeoEditorView = require("../../views/editors/seo");
  module.exports = {
    editSEO: function(seoModel, callback){
      var hasContentChanged = false,
          view = new SeoEditorView({
            model: seoModel
          });
      AppState.setPropsPopUpOpen(true);

      seoModel.on("change", function(){
        hasContentChanged = true;
      });
      seoModel.customMeta.on("add remove change", function(){
        hasContentChanged = true;
      });
      view.once("modal:save", function(seoModel){
        callback(seoModel, { silent: !hasContentChanged });
        seoModel.off("change");
        seoModel.customMeta.off("add remove change");
        view.hide();
        AppState.setPropsPopUpOpen(false);
      });
    }
  };
});
